import { ProductCatalogSelectFilter } from "./ProductCatalogSelectFilter";

const DEFAULT_EMPTY_LABEL = "-";

/**
 * Single-value select using the catalog filter button + panel (same pattern as add-product drawer fields).
 * When `value` is empty, the trigger shows `emptyLabel` (default "-").
 */
export function AddDrawerSelect({
    value,
    onChange,
    options,
    noneLabel,
    /** Shown in the trigger when nothing is selected. */
    emptyLabel = DEFAULT_EMPTY_LABEL,
    /** When true, first row clears selection (same pattern as catalog filters). */
    showAllNone = false,
    /** Label for the clear row when `showAllNone` is true. Defaults to `emptyLabel`. */
    allLabel,
    isLoading = false,
    disabled = false,
    selectClassname = "w-full",
    buttonSelectedClassname = "",
    stackKey,
    openStackKey,
    onStackKeyChange,
    renderInPortal = false,
    closeOnSelect = true,
    /** Custom row content; default is plain `option.label`. */
    renderOption,
}) {
    const selectedOptions =
        value !== "" && value !== null && value !== undefined ? [String(value)] : [];
    const elevated = stackKey != null && openStackKey === stackKey;
    const filter = (
        <ProductCatalogSelectFilter
            showAllNone={showAllNone}
            allLabel={showAllNone ? allLabel ?? emptyLabel : emptyLabel}
            noneLabel={noneLabel}
            options={options}
            isLoading={isLoading}
            disabled={disabled}
            selectedOptions={selectedOptions}
            onChange={(next) => {
                const v = Array.isArray(next) && next.length > 0 ? next[0] : "";
                onChange(v);
            }}
            renderOption={
                renderOption ?? ((option) => <span className="text-gray-900">{option.label}</span>)
            }
            selectClassname={selectClassname}
            buttonSelectedClassname={buttonSelectedClassname}
            renderInPortal={renderInPortal}
            closeOnSelect={closeOnSelect}
            onOpenChange={(open) => {
                if (stackKey != null && onStackKeyChange) {
                    onStackKeyChange(open ? stackKey : null);
                }
            }}
        />
    );
    if (stackKey == null) return filter;
    return <div className={elevated ? "relative z-[200]" : "relative"}>{filter}</div>;
}

export default AddDrawerSelect;
